import FirestoreDocStore from '../../../modules/vuex-firestore/FirestoreDocStore'

const state = {}

const mutations = {}

const getters = {}

const actions = {}

function formatter(d) {
  return d
}

export default new FirestoreDocStore('users/TEST_ROOM', {
  $name: 'users',
  $formatter: formatter,
  state,
  mutations,
  getters,
  actions
})